import React from "react";
import ButtonPrimary from "./ButtonPrimary";
import ProductCart from "./ProductCart";

const products = [
  {
    id: 1,
    title: " Lente DermaSteel",
    // "Caracteristicas": Lenete de policarbonato, filtro UV, diseño ergonocmico, micas clara y gris
  },
  {
    id: 2,
    title: "Lente Dermasteel AL-012",
    // "Características": Lente de policarbonato, con tratamiento antipaño y antirayadyuras.
  },
  {
    id: 3,
    title: "Lente Dermasteel con linternas leed",
    // "Características": Lamparas led, de seguridad policcarbonato y antirrayaduras
  },
  {
    id: 4,
    title: "Lentes armazon tricolor",
    // "Características": Lente de porlicarbonato soporte nasal, sistema retractil
  },
  {
    id: 5,
    title: "Goggle DC",
    // "Características":  Diseñado con 4 valculas de ventilación indirecta dieseño paronámico de 180°.
  },
  {
    id: 6,
    title: "Adaptador para casco",
    // "Características": Con perfil pára sujetarse a la visera de los cascos de seguridad con resorte que sujeta firmemente el casco.
  },
  {
    id: 7,
    title: " Cabezal",
    // "Características": Se ensambla en 5 pestañas ajustabñes, cuenta con perillas laterales de posicionamiento
  },
  // {
  //   id: 8,
  //   title: "Careta para soldar",
  //   "Caracterpisticas": Termoplastico con suspensión de ajuste de matraca
  // },
];

const Visual = () => {
  return (
    <div>
      <section className="inner_page_head" id="product_title">
        <div className="container_fuild">
          <div className="row">
            <div className="col-md-12">
              <div className="full">
                <h3>Visual y Cabeza</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="product_section layout_padding">
        <div className="container">
          <div className="row">
              {products.map((product) => (
                <ProductCart product={product} key={product.id} model={"AV"} />
              ))}
          </div>
        </div>
      </section>
      <section className="my-4">
        <div className="container text-center">
          <h2>
            ¿No encuentras lo que buscabas? <br /> ¡Descarga nuestro catalogo!
            Seguro que lo encuentras
          </h2>
          <ButtonPrimary url="Catalogo audición y visual.pdf" />
        </div>
      </section>
    </div>
  );
};

export default Visual;
